import ConfigurationService from '@/services/isomorphic/ConfigurationService/ConfigurationService';
import type { ConfigName } from '@/configs';
import type Config from '@/services/isomorphic/ConfigurationService/Config';
import { useLocale } from './useLocale';

/**
 * A hook to retrieve a {@link Config} for the given `configName`.
 * @param configName - The name of the config which this object represents. Valid
 * configs can be found at `"libs/configs/src/index.ts"`.
 * @returns The {@link Config} object representing the given configuration key.
 */
export function useConfig<T extends ConfigName>(configName: T): Config<T> {
  const { language, country } = useLocale();
  const config = ConfigurationService.getConfig(configName, language, country);
  return config;
}
